function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.79999 3.29999H27.2C27.5 3.29999 27.7 3.49999 27.7 3.79999V27.3C27.7 27.6 27.5 27.8 27.2 27.8H3.79999C3.49999 27.8 3.29999 27.5 3.29999 27.3V3.79999C3.29999 3.49999 3.59999 3.29999 3.79999 3.29999ZM4.29999 26.8H26.7H26.8V4.19999H4.29999V26.8ZM24.5 13.5H17.9C17.6 13.5 17.5 13.3 17.5 13V6.4C17.5 6.2 17.6 6 17.9 6H24.5C24.8 6 25 6.2 24.9 6.4V13.1C24.9 13.3 24.8 13.5 24.5 13.5ZM24 6.9H18.3V12.6H24V6.9ZM6.6 24.5H8.2V20.7C8.2 20.5 8.2 20.3 8.3 20.2C8.4 19.7 8.9 19.3 9.5 19.3C10.3 19.3 10.6 19.9 10.6 20.8V24.5H12.2V20.6C12.2 20.4 12.2 20.2 12.3 20.1C12.5 19.6 12.9 19.2 13.4 19.2C14.2 19.2 14.6 19.8 14.6 20.9V24.5H16.2V20.7C16.2 18.6 15.1 17.9 14 17.9C13.5 17.9 13.1 18 12.7 18.3C12.4 18.5 12.1 18.8 11.9 19.1C11.6 18.4 11 17.9 10.1 17.9C9 17.9 8.4 18.5 8.1 19L8 18H6.5C6.5 18.2884 6.52311 18.5769 6.54711 18.8764C6.57304 19.2 6.6 19.5365 6.6 19.9V24.5ZM17 18H18.3V18.6H16V18.2L16.4 17.8C17.2 17.1 17.6 16.7 17.6 16.2C17.6 15.9 17.5 15.6 17 15.6C16.7825 15.6 16.6175 15.7051 16.467 15.8011C16.41 15.8375 16.355 15.8725 16.3 15.9L16.1 15.4C16.4 15.2 16.8 15 17.2 15C17.9 15 18.3 15.4 18.3 16C18.3 16.7 17.9 17.1 17.3 17.7L17 18Z",
  fill: "#1C33C8"
});

var SvgArea = function SvgArea(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArea, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/area.23e0e867.svg";
export { ForwardRef as ReactComponent };